document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach((el) => observer.observe(el));
});

document.addEventListener('DOMContentLoaded', () => {
  const floatingCta = document.getElementById('floating-cta');
  const backToTop = document.getElementById('back-to-top');
  const legalBar = document.getElementById('footer-legal');
  if (!legalBar || (!floatingCta && !backToTop)) return;

  const gap = 16;

  const update = () => {
    const rect = legalBar.getBoundingClientRect();
    const overlap = window.innerHeight - rect.top + gap;
    const pushUp = Math.max(overlap, 0);

    if (floatingCta) {
      floatingCta.style.transform = pushUp ? `translateY(-${pushUp}px)` : '';
    }

    if (backToTop) {
      const visible = window.scrollY > 500;
      backToTop.classList.toggle('opacity-0', !visible);
      backToTop.classList.toggle('pointer-events-none', !visible);
      const slide = visible ? 0 : -8;
      backToTop.style.transform = `translateY(${slide - pushUp}px)`;
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  if (backToTop) {
    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('menu-toggle');
  const menu = document.getElementById('mobile-menu');
  const iconOpen = document.getElementById('menu-icon-open');
  const iconClose = document.getElementById('menu-icon-close');
  if (!toggle || !menu) return;

  const setOpen = (open) => {
    menu.classList.toggle('hidden', !open);
    menu.classList.toggle('flex', open);
    iconOpen.classList.toggle('hidden', open);
    iconClose.classList.toggle('hidden', !open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('overflow-y-hidden', open);
  };

  toggle.addEventListener('click', () => {
    setOpen(menu.classList.contains('hidden'));
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 960) setOpen(false);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const lightbox = document.getElementById('cv-lightbox');
  const buttons = document.querySelectorAll('.js-cv-link');
  if (!lightbox || !buttons.length) return;

  const name = document.getElementById('cv-lightbox-name');
  const role = document.getElementById('cv-lightbox-role');
  const edu = document.getElementById('cv-lightbox-edu');
  const focus = document.getElementById('cv-lightbox-focus');
  const close = document.getElementById('cv-lightbox-close');

  const open = (btn) => {
    name.textContent = btn.dataset.name || '';
    role.textContent = btn.dataset.role || '';
    edu.textContent = btn.dataset.edu || '';
    focus.textContent = btn.dataset.focus || '';
    lightbox.classList.remove('hidden');
    lightbox.classList.add('flex');
  };

  const hide = () => {
    lightbox.classList.add('hidden');
    lightbox.classList.remove('flex');
  };

  buttons.forEach((btn) => btn.addEventListener('click', () => open(btn)));
  close.addEventListener('click', hide);
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) hide();
  });
});
